import { produce } from "immer";
import { AnyAction } from "redux";

import {
  GET_GROUP_SUCCESS,
  UPDATE_GROUP_SUCCESS,
  CREATE_GROUP_SUCCESS,
  GET_AGENCY_SUCCESS,
  UPDATE_AGENCY_SUCCESS,
} from "../constants";

export interface IGroupState {
  group: IGroup | null;
}

export interface IGroup {
  label: string;
  email: string;
  phone: string;
  groupId: string;
  address: {
    additionalAddress?: string;
    city: string;
    address: string;
    latitudeY: string;
    longitudeX: string;
    zip: string;
    digicode: string;
    id: string;
    residenceName: string;
  };
}

export interface IAgencyState {
  group: IAgency | null;
}

export interface IAgency {
  label: string;
  email: string;
  phone: string;
  siren: string;
  groupId: string;
  address: {
    additionalAddress?: string;
    city: string;
    address: string;
    latitudeY: string;
    longitudeX: string;
    zip: string;
    digicode: string;
    id: string;
    residenceName: string;
  };
  imageUrl: any;
}

export interface IResponse {
  message: string;
  data?: IGroup;
  error?: string;
}

const initGroupState = {
  group: null,
} as IGroupState;

const groupReducer = produce((draft = initGroupState, action: AnyAction) => {
  switch (action.type) {
    case GET_GROUP_SUCCESS:
      draft.group = action.payload;
      break;
    case CREATE_GROUP_SUCCESS:
      draft.group = action.payload;
      break;
    case UPDATE_GROUP_SUCCESS:
      draft.group = action.payload;
      break;
    default:
      return draft;
  }
});

const initAgencyState = {
  group: null,
} as IAgencyState;

const agencyReducer = produce((draft = initAgencyState, action: AnyAction) => {
  switch (action.type) {
    case GET_AGENCY_SUCCESS:
      draft.agency = action.payload;
      break;
    case UPDATE_AGENCY_SUCCESS:
      draft.agency = action.payload;
      break;
    default:
      return draft;
  }
});

export default { groupReducer, agencyReducer };
